<template>
    <div>
        <div class="choose_auth clearfix" ref='choose_box'>
            <div class="choose_item" :ref='"choose_"+index' v-for="(item,index) in chooseData" v-show="!(globalTabType() == 'new' && item.isTaoli)" :key='index'><!--:class="{clear: item.type == 'line'}"-->
                <template v-if="item.type != 'line'">
                    <AuthChooseItem :selected='item.select' :disable='item.disable'
                        :hassub='item.sublist && item.sublist.length > 0' :name='item.name' :open='item.open'
                        :bought='item.bought' :link="item.link" @click="itemClick(item,index)" />
                        
                    <span v-if="$route.params.id == 128 && globalTabType() == 'add'" style="margin-bottom: 10px;color:#9B0000;position:relative;top:18px;margin-left: 15px;">*购买5C收费功能模块在“新购”栏目进行</span>
                    <!-- <span v-if="$route.params.id == 110 && globalTabType() == 'add'" style="margin-bottom: 10px;color:#9B0000;position:relative;top:18px;margin-left: 15px;">*购买10C收费功能模块在“新购”栏目进行</span> -->
                    <div class="clearfix"></div>
                    <!-- <a v-if='item.link' :href='item.link' target="_blank">>>>查看介绍</a> -->
                    <div class="sublist_wrapper" @click.stop="_=>{}"
                        v-show='item.sublist && item.sublist.length > 0 && item.open' :style='{height: popHeight(item), left: style(index)}'>
                        <div class="arrow" :class="themeColor(item)" :style='{left: arrowPos(index)}'></div>
                        <vue-scroll :ref="'scroller_'+index" :style='{height: tableHeight(item)}'>
                        
                            <HistoryTable v-if='item.name == "历史数据API"' @choose='choose(...arguments, index)' :itemname='item.name' :ref='"autab_"+index' v-model='authPrice[index]' :authData="item.sublist"/>
                            <AuthTable v-else @choose='choose(...arguments, index)' :ref='"autab_"+index' :itemname='item.name'
                                v-model='authPrice[index]' :authData="item.sublist" :themeColor="themeColor(item)"/>
                        </vue-scroll>
                        
                        <div v-if="item.name == '历史数据API'" class='panel_foot' :style="{height: footHeight(item)}" style="text-align: right;">
                            <p class='tips' v-if="globalTabType() == 'add'">注：<span>以上单价为该服务保底价格，如所使用的wh9账号剩余时间不足12个月，即按保底价费用收取服务费。</span></p>
                            <button class="history_finish" @click.stop='finishHistory'>完成</button>
                        </div>
                        <div v-else class='panel_foot' style="height:80px;">
                            <p class='tips' :style="{visibility: item.name && item.name.indexOf('境外')>=0 ? 'visible' : 'hidden'}">小贴士：<span>按境外交易所规定，实时行情数据收取终端费(USER FEE)，由信息商收取每月向交易所结算。</span></p>
                            <button @click.stop='closePanel'>完成</button>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    import HistoryTable from '../components/HistoryTable.vue'
    export default {
        name: 'auth-choose',
        components: {
            HistoryTable
        },
        props: {
            authConfigData: {
                type: Array,
                default: []
            },
            isMonth: Boolean,
            preClick: {
                type: Function,
                default: () => false
            }
        },
        inject: ['changeAuthPrice', 'changeAuthOldPrice','selectAuthItem', 'currentPage','globalTabType', 'setHistoryIsPoping'],
        provide () {
            let self = this
            return {
                historyHandleOpen () {
                    let historyIndex = self.chooseData.findIndex(v=>v.name == '历史数据API')
                    self.$refs['scroller_'+historyIndex][0].scrollTo({y: '81%'})
                }
            }
        },
        data: () => ({
            chooseData: [],
            authPrice: []
        }),
        methods: {
            popHeight (item) {
                if (this.$route.params.id == 110 || this.$route.params.id == 125) return '250px'
                else {
                    switch (item.name) {
                        case '历史数据API':
                            return this.globalTabType() == 'add' ? '385px' : '345px'
                        default: 
                            return '370px'
                    }
                }
            },
            tableHeight (item) {
                if ((this.$route.params.id == 76 || this.$route.params.id == 123) && item.name?.indexOf("境外")>=0) return 'calc(100% - 90px)'
                else {
                    switch (item.name) {
                        case '历史数据API':
                            return this.globalTabType() == 'add' ? 'calc(100% - 80px)' : 'calc(100% - 40px)'
                        default: 
                            return 'calc(100% - 80px)'
                    }
                }
            },
            footHeight (item) {
                if (item.name == '历史数据API' && this.globalTabType() == 'add') return '80px'
                else return '30px'
            },
            titleName (item) {
                switch(item.name) {
                    case '历史数据API':
                        return '服务名称'
                    default:
                        return '授权名称'
                }
            },
            itemClick(item, index) {
                if (this.preClick()) return

                let openItem = this.chooseData.find(v=>v.open)
                let historyIndex = this.chooseData.findIndex(v=>v.name == '历史数据API')
                if (openItem && openItem.name == '历史数据API' && this.$refs['autab_' + historyIndex][0].isUnFinishSelect) return this.finishHistory()
                
                let self = this
                if (!item.sublist || item.sublist.length <= 0) {
                    item.select = !item.select
                }
                if (item.sublist && item.sublist.length > 0) {
                    var bol = !item.open
                    this.chooseData.forEach((v, i) => {
                        if (v.open) {
                            v.open = false
                        }
                        if (v.sublist && v.sublist.length > 0 && self.$refs["autab_" + i][0].getSelect().filter(
                                v => !v.isChecked).length <= 0 && index != i) {
                            v.select = false
                        }
                    })
                    item.open = bol
                    if (this.$refs["autab_" + index][0].getSelect().filter(v => !v.isChecked).length >
                        0) { //获取是否有选中的子授权项
                        item.select = true //如果有选中，则保持当前项选中的状态
                    }
                } else {
                    this.chooseData.forEach((v, i) => {
                        v.open = false
                    })
                    if (item.select) {
                        this.$set(this.authPrice, index, parseInt(this.isMonth ? item.monthprice : item.price))
                    } else {
                        this.$set(this.authPrice, index, 0)
                    }

                }
                setTimeout(()=>{
                    self.$refs['scroller_'+index][0].scrollTo({y: 0},0)
                })
            },
            style(index) {
                if (!this.$refs.choose_box || !this.$refs["choose_" + index] || !this.$refs["choose_" + index][0])
                    return
                let dad = this.$refs.choose_box.getBoundingClientRect()
                let sun = this.$refs["choose_" + index][0].getBoundingClientRect()
                return (dad.left - sun.left) + 'px'
            },
            arrowPos(index) {
                if (!this.$refs.choose_box || !this.$refs["choose_" + index] || !this.$refs["choose_" + index][0])
                    return
                let dad = this.$refs.choose_box.getBoundingClientRect()
                let sun = this.$refs["choose_" + index][0].getBoundingClientRect()
                return (sun.left - dad.left + sun.width / 2 - 5) + 'px'
            },
            getSelect() {
                var ids = []
                var self = this
                this.chooseData.forEach((v, i) => {
                    if (v.sublist && v.sublist.length > 0) {
                        (self.$refs["autab_" + i] && self.$refs["autab_" + i][0]) && self.$refs["autab_" + i][0]
                            .getSelect().forEach(item => {
                                ids.push(item)
                            })
                    } else if (v.select) {
                        ids.push(v)
                    }
                })
                this.selectAuthItem(ids)
            },
            getSelections() {
                var selections = []
                var self = this
                this.chooseData.forEach((v, i) => {
                    if (v.select) {
                        let obj = {}
                        obj.id = v.id
                        obj.name = v.name
                        if (v.sublist && v.sublist.length > 0) {
                            obj.children = wh.disDeepClone((self.$refs["autab_" + i] && self.$refs["autab_" + i][0]) && self.$refs["autab_" + i][0]
                                .getSelect())
                        }
                        selections.push(obj)
                    }
                })
                return selections
            },
            choose(click, item, index, curIndex) {
                let self = this
                //2024-9-9和王晶晶沟通，只限制欧交所就行
                if (self.currentPage() == 'add' && self.$store.state.addbuy.user != '' && self.$store.state.addbuy.user
                    .length > 10 && (item.productlink == 'EUREX')) {
                    self.$market.alert({
                        content: '你现在使用的账号位数超长无法加购数据授权，请联系4008113366解决。'
                    })
                    return
                }
                // if (!item.cselect && this.globalTabType() != 'add') {
                //     if ((this.$route.params.id == 1 && ['44','46','347',"43","165"].some(v=> v == item.id)) || (this.$route.params.id == 124 && ["498","500","520","497","514"].some(v=> v == item.id))) {
                //         this.$market.alert({
                //             content: '此授权即将下架，选购此授权后续将不能选择2023年1月1日之后的时间开通账号。'
                //         })
                //     }
                // }
                click(item, index, () => {
                    if (self.$refs["autab_" + curIndex][0].getSelect().filter(v => !v.isChecked).length > 0) {
                        self.chooseData[curIndex].select = true
                    } else {
                        self.chooseData[curIndex].select = false
                    }
                })

            },
            closePanel() {
                let self = this
                self.chooseData.forEach((v, i) => {
                    
                    self.$refs['scroller_'+i][0]?.scrollTo({y: 0},0)
                    setTimeout(()=>{
                        v.open = false
                    })
                    if (v.sublist && v.sublist.length > 0 && self.$refs["autab_" + i][0] && self.$refs[
                            "autab_" + i][0].getSelect().filter(v => !v.isChecked).length <= 0) {
                        v.select = false
                    }
                })
            },
            finishHistory () {
                let historyIndex = this.chooseData.findIndex(v=>v.name == '历史数据API')
                if (!this.$refs['autab_' + historyIndex][0].isUnFinishSelect) {
                    this.closePanel()
                } else {
                    this.setHistoryIsPoping(true)
                    this.$market.alert({
                        content: `请继续在列表中选择历史数据API对应的${this.$refs['autab_' + historyIndex][0].isLackOfPeriod ? '周期':'交易所'}，否则点击右上角×退出本窗口。`,
                        btnTxt: '继续',
                        closeBtn: true,
                        closeCall: ()=>{
                            this.$refs['autab_' + historyIndex][0].cancelAll()
                            this.closePanel()
                            this.setHistoryIsPoping(false)
                        }
                    })
                }
            },
            themeColor(item) {
                if (item.name == '国内五档数据等' || item.name == '国内实时数据') return 'blue'
                else if (item.name == '境外实时数据') return 'yellow'
                else if (item.name == '历史数据API') return 'white'
                else return ''
            },
            cancelEach (call) {
                this.chooseData.forEach((v,i)=>{
                    if (call && call(v)) {
                        this.$set(v,'select',false)
                        this.$refs['autab_'+i][0].cancelAll()
                    }
                    
                })
            },
            setDisableEach (call) {
                this.chooseData.forEach((v,i)=>{
                    this.$set(v,'disable',call && call(v))
                }) 
            },
            selectItemsById (arr) {
                arr.forEach(v=>{
                    let index = this.chooseData.findIndex(el=> el.id == v.id),
                        target = this.chooseData[index]
                    this.$set(target,'select',true)
                    if (v.children && v.children.length > 0) {
                        v.children.forEach(item=> {
                            this.$refs["autab_" + index] && this.$refs["autab_" + index][0].selectItemByMemory(item)
                        })
                    } else {
                        this.$set(this.authPrice, index, parseInt(target.price))
                    }
                })
            }
        },
        computed: {
            selectAuth() {
                return this.chooseData.filter(v=>v.select).map(v=>{
                    let instance = this.$refs['autab_'+this.chooseData.findIndex(el=>el.id == v.id)]
                    return {
                        ...v,
                        children: instance && instance[0].getSelect()
                    }
                })
            },
            hasHistoryData () {
                let target = this.chooseData.find(v=>v.name == '历史数据API')
                return target?.select
            }
        },
        watch: {
            authConfigData: {
                handler(val) {
                    this.chooseData = val.map(v => {
                        var obj = {
                            ...v
                        }
                        if (obj.select == undefined) {
                            obj.select = false
                        }
                        if (obj.disable == undefined) {
                            obj.disable = false
                        }
                        if (obj.open == undefined) {
                            obj.open = false
                        }
                        return obj
                    })
                    this.authPrice = []
                    for (let i = 0; i < this.chooseData.length; i++) {
                        this.authPrice.push(0)
                    }
                    this.$nextTick(() => {
                        this.getSelect()
                    })
                },
                immediate: true,
                deep: true
            },
            authPrice: {
                handler(val) {
                    let price = 0, old_price = 0
                    for (let i = 0; i < val.length; i++) {
                        price += parseFloat(val[i])
                        console.log(this.chooseData[i])
                        if (!this.chooseData[i].sublist || this.chooseData[i].sublist.length == 0) {
                            if (this.chooseData[i].select) {
                                old_price += parseInt(this.chooseData[i].oldPrice || 0)
                            }
                        } else if (this.$refs['autab_' + i]?.[0]) {
                            old_price += this.$refs['autab_' + i][0].totalOldPrice
                        }
                    }
                    this.changeAuthOldPrice(old_price)
                    this.changeAuthPrice(price)
                    this.getSelect()
                },
                immediate: true,
                deep: true
            },
            isMonth (val) {
                // if (val) {
                //     this.authPrice.forEach((v,i)=>{
                //         if (v != 0 && this.chooseData[i].name == "多账号下单模块") {
                //             this.$set(this.authPrice,i,parseFloat(this.chooseData[i].monthprice))
                //         }
                //     })
                // } else {
                //     this.authPrice.forEach((v,i)=>{
                //         if (v != 0 && this.chooseData[i].name == "多账号下单模块") {
                //             this.$set(this.authPrice,i,parseFloat(this.chooseData[i].price))
                //         }
                //     })
                // }
            }
        },
        mounted() {
            let self = this
            window.addEventListener('click', () => {
                let openItem = this.chooseData.find(v=>v.open)
                if (openItem && openItem.name == '历史数据API') {
                    this.finishHistory()
                } else {
                    this.closePanel()
                }
                
            })
        }
    }
</script>

<style scoped>
    .choose_item {
        float: left;
        position: relative;
        margin-bottom: 8px;
    }

    .choose_item.clear {
        clear: both;
    }
    .choose_item a {
        /* margin-top: 3px; */
        display: block;
        text-decoration: none;
        color: rgb(0, 102, 253);
    }

    .sublist_wrapper {
        width: 506px;
        height: 370px;
        box-sizing: border-box;
        border: 1px solid rgb(181, 194, 203);
        position: absolute;
        background: rgb(255, 255, 255);
        z-index: 6;
        top: 110%;
    }

    .sublist_wrapper .arrow::before {
        content: '';
        border-bottom: 10px solid rgb(181, 194, 203);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -9px;
        z-index: 3;
    }

    .sublist_wrapper .arrow::after {
        content: '';
        border-bottom: 10px solid rgb(231, 235, 238);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -8px;
        z-index: 3;
    }

    .sublist_wrapper .arrow.blue::after {
        content: '';
        border-bottom: 10px solid #bcdcf5;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -8px;
        z-index: 3;
    }

    .sublist_wrapper .arrow.yellow::after {
        content: '';
        border-bottom: 10px solid #ffebcc;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -8px;
        z-index: 3;
    }
    .sublist_wrapper .arrow.pink::after {
        content: '';
        border-bottom: 10px solid #f7e2e1;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -8px;
        z-index: 3;
    }
    .sublist_wrapper .arrow.white::after {
        content: '';
        border-bottom: 10px solid #fff;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        top: -8px;
        z-index: 3;
    }

    .sublist_wrapper .arrow {
        position: absolute;
    }

    .panel_foot {
        height: 50px;
        /* box-shadow: 0 -2px 3px 3px #999; */
        position: relative;
        z-index: 5;
        text-align: right;
        padding-top: 5px;
        box-sizing: border-box;
    }

    .panel_foot button {
        white-space: nowrap;
        color: white;
        font-size: inherit;
        border: 0;
        outline: 0;
        vertical-align: middle;
        background: rgb(6, 96, 172);
        font-size: 14px;
        font-family: 'microsoft yahei';
        border-radius: 20px;
        margin-right: 20px;
        padding: 0px 9px 2px;
    }

    .panel_foot .tips {
        text-align: left;
        margin-bottom: 10px;
        padding-left: 20px;
        color: rgb(93, 29, 46);
        white-space: nowrap;
    }
    .panel_foot .link {
        text-align: left;
        margin-bottom: 10px;
        padding-left: 20px;
        color: rgb(47, 123, 223);
        white-space: nowrap;
    }
    .panel_foot .tips span {
        display: inline-block;
        white-space: normal;
        width: 410px;
        vertical-align: top;
    }

    .panel_foot button.history_finish {
        background-color: #0660ac;
        border-radius: 20px;
        margin-right: 20px;
        padding: 0px 9px 2px;
    }
</style>